// ----------------------------------------------------------------
// DOM Helpers
// Credit: https://gist.github.com/paulirish/12fb951a8b893a454b32
// ---------------------------------------------------------------

window.$ = document.querySelector.bind( document );
window.$$ = document.querySelectorAll.bind( document );

Node.prototype.on = window.on = function ( name, fn ) {
  this.addEventListener( name, fn );
}

Node.prototype.off = window.off = function ( name, fn ) {
  this.removeEventListener( name, fn );
}

NodeList.prototype.__proto__ = Array.prototype;

NodeList.prototype.on = NodeList.prototype.addEventListener = function ( name, fn ) {
  this.forEach( function ( elem, i ) {
    elem.on( name, fn );
  } );
};

NodeList.prototype.off = NodeList.prototype.removeEventListener = function ( name, fn ) {
  this.forEach( function ( elem, i ) {
    elem.off( name, fn );
  } );
};

// --------------------------------------------------------------------------------------
// Prevent error in ie11 that node.remove is missing and polyfill with mdn
// --------------------------------------------------------------------------------------
// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
( function ( arr ) {
  arr.forEach( function ( item ) {
    if ( item.hasOwnProperty( 'remove' ) ) {
      return;
    }
    Object.defineProperty( item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        this.parentNode.removeChild( this );
      }
    } );
  } );
} )( [ Element.prototype, CharacterData.prototype, DocumentType.prototype ] );